import { h } from "preact";
import { Text } from "preact-i18n";
import Button from "components/Button/Button";
import styles from "./style.module.scss";
import { SelectionSummary } from "services/selectionGroups";
interface Props {
    summary: SelectionSummary;
    addressLimit?: number;
    addressMinimum?: number;
    addressCount: number;
    isEditable: boolean;
    disabled: boolean;
    onConfirm(): void;
    onClose?(): void;
}
const SelectionFooter = ({
    summary,
    addressLimit,
    addressMinimum,
    addressCount,
    isEditable,
    disabled,
    onConfirm,
    onClose,
}: Props) => {
    return (
        <div className={styles.mvAsidePanelFooter}>
            {summary?.aboveAddressLimit && addressLimit && (
                <p className={styles.addressLimitMessage}>
                    <Text
                        id="general.messages.addressLimitExceeded"
                        fields={{
                            max: addressLimit,
                            count: addressCount - addressLimit,
                        }}
                        plural={addressCount - addressLimit}
                    >
                        {`You can only select ${addressLimit} addresses.${" "}
                            ${addressCount - addressLimit} addresses will not be
                            selected.`}
                    </Text>
                </p>
            )}
            {summary?.belowAddressMinimum && addressMinimum && (
                <p className={styles.addressLimitMessage}>
                    <Text
                        id="general.messages.addressMinimum"
                        fields={{
                            min: addressMinimum,
                        }}
                    >
                        {`Select at least ${addressMinimum} addresses to continue.`}
                    </Text>
                </p>
            )}
            {isEditable ? (
                <Button
                    type="primary"
                    className={styles.mvAsidePanelConfirmButton}
                    disabled={disabled}
                    onClick={() => {
                        onConfirm();
                    }}
                >
                    <Text id="general.buttons.confirmSelection">
                        Confirm selection
                    </Text>
                </Button>
            ) : (
                <Button type="secondary" outline onClick={onClose}>
                    <Text id="general.buttons.closeModal">Close</Text>
                </Button>
            )}
        </div>
    );
};
export default SelectionFooter;
